import React from "react";
import { useApp } from "@/context/AppContext";
import { PROPERTY_TYPES } from "@/lib/propertyTypes";

/**
 * Horizontal chip strip to filter by property type. `value` is the current
 * selected type (empty string = "all"). `onChange(nextValue)` toggles.
 */
export default function PropertyTypeChips({ value, onChange, testIdPrefix = "chip-type" }) {
  const { lang } = useApp();
  const chip = (active) =>
    `text-[11px] tracking-[0.15em] uppercase px-3 py-1.5 rounded-full transition-all border ${
      active
        ? "bg-[#C5A880] text-black border-[#C5A880] shadow-sm"
        : "bg-transparent text-[#8A7658] border-[#D8CFBB] hover:border-[#C5A880] hover:text-[#4A3F30]"
    }`;

  return (
    <div
      className="flex items-center gap-2 flex-wrap overflow-x-auto -mx-1 px-1"
      data-testid={`${testIdPrefix}-strip`}
      role="tablist"
      aria-label={lang === "it" ? "Filtro tipo di immobile" : "Property type filter"}
    >
      <button
        type="button"
        data-testid={`${testIdPrefix}-all`}
        role="tab"
        aria-selected={!value}
        onClick={() => onChange("")}
        className={chip(!value)}
      >
        {lang === "it" ? "Tutti" : "All"}
      </button>
      {PROPERTY_TYPES.map((pt) => (
        <button
          key={pt.value}
          type="button"
          data-testid={`${testIdPrefix}-${pt.value}`}
          role="tab"
          aria-selected={value === pt.value}
          onClick={() => onChange(value === pt.value ? "" : pt.value)}
          className={chip(value === pt.value)}
        >
          {pt[lang] || pt.it}
        </button>
      ))}
    </div>
  );
}
